<opac-dialog size="medium" [open]="isOpen()" [title]="'ratings.title' | translate" (closed)="closeDialog()">
  <div class="rating-container">
    <span>{{ 'ratings.ownRating' | translate }}</span>
    <opac-rating [rating]="rating()" [ratedByUser]="hasUserVoted()" (change)="setRating($event)"></opac-rating>
  </div>

  <opac-textarea
    #descriptionTextarea
    [counter]="true"
    [maxLength]="MAX_COMMENT_LENGTH"
    [invalid]="descriptionError() !== null"
    [ngModel]="comment()"
    (ngModelChange)="setComment($event)">
    {{ 'ratings.ownComment' | translate }}

    <span slot="error" *ngIf="descriptionError() !== null"> {{ descriptionError() | translate }} </span>
  </opac-textarea>

  <p *ngIf="userActionRequiredComputed()" class="rating-error">{{ 'ratings.required' | translate }}</p>

  <opac-button slot="actions" (click)="submit()">{{ 'general.save' | translate }}</opac-button>
</opac-dialog>
